import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'MyContestDrawSetting',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            contestId: this.$route.params.contestId,
            tempDrawInfos: [],
            drawInfos: [],
            currentDrawInfo: null,
            canStartNew: false,
            subareaCount: this.$route.query.subareaCount,
            sessionCount: this.$route.query.sessionCount,
            showPop: false,
            list: [],
            areaCurrentData: {
                drawIndex: 0,
                areaIndex: 0,
                target: 'area',
                result: []
            },
            showDeleteAlert: false,
            targetDrawInfo: null,
        }
    },
    created() {
        this.getDrawInfos()
        for (let i = 0; i < this.subareaCount; i++) {
            this.list.push(i + 1)
        }
    },
    methods: {
        async getDrawInfos() {
            try {
                this.tempDrawInfos = await contestApi.getDrawInfos(this.contestId)
                var drawInfos = []
                for (let i = 0; i < this.tempDrawInfos.length; i++) {
                    var drawInfo = this.tempDrawInfos[i];
                    console.log(drawInfo.info);
                    if (drawInfo.info === '') {
                        this.$set(drawInfo, 'info', [{}])
                    } else {
                        this.$set(drawInfo, 'info', JSON.parse(drawInfo.info))
                    }

                    // fix接口返回结构错误
                    if (!Array.isArray(drawInfo.info)) {
                        drawInfo.info = drawInfo.info.info
                    }

                    if (drawInfo.info.length === 0) {
                        drawInfo.info.push({})
                    }
                    drawInfos.push(drawInfo)
                }
                this.drawInfos = drawInfos;
                if (this.drawInfos.length === 0) {
                    this.startNewSession()
                }
                this.canStartNew = this.drawInfos.length < this.sessionCount
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async startDraw(index) {
            this.$toast.loading()
            // this.$toast.loading({forbidClick: true})
            try {
                let result
                console.log(JSON.stringify(this.drawInfos[index].info))
                result = await contestApi.startDraw(this.contestId, JSON.stringify(this.drawInfos[index].info), index + 1)
                console.log(result)
                this.getDrawInfos()
                this.$toast.clear()
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async saveDrawInfo() {
            this.$toast.loading()
            try {
                const saveArray = [];
                for (let i = 0; i < this.drawInfos.length; i++) {
                    var info = []
                    for (let j = 0; j < this.drawInfos[i].info.length; j++) {
                        var areaInfo = this.drawInfos[i].info[j];
                        if (i === 0) {
                            areaInfo.drawArea = areaInfo.area
                        }
                        if (JSON.stringify(areaInfo) !== '{}') {
                            info.push(areaInfo)
                        }
                    }
                    saveArray.push(info)
                }
                await contestApi.saveDrawInfo(this.contestId, JSON.stringify(saveArray))
                this.getDrawInfos()
                this.$toast.success("保存成功")
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        async deleteDraw(session) {
            this.$toast.loading()
            try {
                let result
                result = await contestApi.deleteDraw(this.contestId, session)
                console.log(result)
                this.getDrawInfos()
                this.$toast.success("撤销成功")
            } catch (error) {
                this.$toast.fail(error.message)
            }
        },
        onDeleteDrawClick(drawInfo) {
            this.targetDrawInfo = drawInfo
            this.showDeleteAlert = true
        },
        onShowDeleteAlertConfirmBtnClick() {
            this.showDeleteAlert = false
            this.deleteDraw(this.targetDrawInfo.session)
        },
        startNewSession: function () {
            this.drawInfos.push({
                index: this.drawInfos.length,
                info: [{}],
                areaIndex: [0, 0],
                drawTime: null
            })
            this.canStartNew = this.drawInfos.length < this.sessionCount
        },
        addAreaSet(drawInfoIndex) {
            this.drawInfos[drawInfoIndex].info.push({})
        },
        deleteAreaSet(drawInfoIndex, areaIndex) {
            this.drawInfos[drawInfoIndex].info.splice(areaIndex, 1)
            if (this.drawInfos[drawInfoIndex].info.length < 1) {
                this.drawInfos[drawInfoIndex].info.push({})
            }
        },
        selectSourceArea(drawInfoIndex, index) {
            this.showPop = true;
            this.areaCurrentData.drawIndex = drawInfoIndex
            this.areaCurrentData.areaIndex = index
            this.areaCurrentData.target = 'area'
        },
        selectTargetArea(drawInfoIndex, index) {
            this.showPop = true;
            this.areaCurrentData.drawIndex = drawInfoIndex
            this.areaCurrentData.areaIndex = index
            this.areaCurrentData.target = 'targetArea'
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        areaSure() {
            const currentAreaInfo = this.drawInfos[this.areaCurrentData.drawIndex].info[this.areaCurrentData.areaIndex]
            var areaStr = ""
            for (let i = 0; i < this.areaCurrentData.result.length; i++) {
                if (i === 0) {
                    areaStr = this.areaCurrentData.result[0]
                } else {
                    areaStr = areaStr + "," + this.areaCurrentData.result[i]
                }
            }
            if (this.areaCurrentData.target === 'area') {
                this.$set(currentAreaInfo, 'drawArea', areaStr)
            } else if (this.areaCurrentData.target === 'targetArea') {
                this.$set(currentAreaInfo, 'area', areaStr)
            }
            this.$set(this.drawInfos[this.areaCurrentData.drawIndex].info, this.areaCurrentData.areaIndex, currentAreaInfo)
            this.areaCurrentData.result = [];
            this.showPop = false;
        },

    }
}
